"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpectedValueBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const react_1 = require("react");
const expected_values_options_1 = require("../../../shared/expected-values-options");
const ExpectedValueBadge = ({ typeId, prefix, deleteTooltip, endNode, onDelete, }) => {
    const [hovered, setHovered] = (0, react_1.useState)(false);
    const { icon, title } = expected_values_options_1.expectedValuesOptions[typeId];
    const isArray = typeId === "array";
    const isObject = typeId === "object";
    const isDataType = !isArray && !isObject;
    const prefixTextRef = (0, react_1.useRef)(null);
    const [prefixContainerWidth, setPreficContainerWidth] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const textWidth = prefixTextRef.current?.getBoundingClientRect().width;
        setPreficContainerWidth(textWidth ? textWidth + 24 : 0);
    }, [prefix]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), children: [prefix ? ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    display: "flex",
                    background: ({ palette }) => palette.gray[60],
                    borderTopLeftRadius: 4,
                    borderBottomLeftRadius: isArray ? 0 : 4,
                    padding: 1.25,
                    alignItems: "center",
                    width: prefixContainerWidth,
                    transition: ({ transitions }) => transitions.create("width"),
                }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { ref: prefixTextRef, variant: "smallCaps", sx: {
                        fontSize: 11,
                        color: ({ palette }) => palette.white,
                        whiteSpace: "nowrap",
                    }, children: prefix }) })) : null, (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    background: ({ palette }) => palette.gray[70],
                    paddingX: 1.5,
                    pr: 0,
                    alignItems: "center",
                    borderRadius: 1,
                    position: "relative",
                    overflow: "hidden",
                    ...(prefix
                        ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }
                        : {}),
                    ...(!isDataType
                        ? {
                            width: "100%",
                            borderBottomLeftRadius: isObject && !prefix ? 4 : 0,
                            borderBottomRightRadius: 0,
                        }
                        : {}),
                }, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1, py: 1, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: {
                                            icon,
                                        }, sx: {
                                            color: ({ palette }) => palette.gray[40],
                                            marginRight: 1.5,
                                        } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallTextLabels", sx: {
                                            fontWeight: 500,
                                            color: ({ palette }) => palette.white,
                                            py: 0.25,
                                            mr: 1.25,
                                        }, children: title }), isDataType ? ((0, jsx_runtime_1.jsx)(design_system_1.Chip, { label: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallCaps", sx: { fontSize: 11 }, children: "DATA TYPE" }), color: "blue", sx: {
                                            mr: 1.25,
                                            borderWidth: 0,
                                            color: ({ palette }) => palette.blue[70],
                                            [`.${material_1.chipClasses.label}`]: {
                                                px: 1,
                                                py: 0.25,
                                            },
                                        } })) : null] }), (0, jsx_runtime_1.jsx)(material_1.Box, { pr: 1.5, children: endNode })] }), onDelete ? ((0, jsx_runtime_1.jsx)(material_1.Collapse, { orientation: "horizontal", in: hovered, sx: { height: 1 }, children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: deleteTooltip ?? "", placement: "top", PopperProps: {
                                sx: {
                                    [`.${material_1.tooltipClasses.tooltip}`]: { mb: "0px !important" },
                                },
                            }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { onClick: onDelete, sx: ({ palette }) => ({
                                    display: "flex",
                                    alignItems: "center",
                                    height: "100%",
                                    px: 1.5,
                                    backgroundColor: palette.gray[60],
                                    color: palette.gray[90],
                                    cursor: "pointer",
                                    ":hover": {
                                        backgroundColor: palette.gray[90],
                                        color: palette.red[50],
                                    },
                                }), children: (0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faClose, sx: {
                                        fontSize: "13px !important",
                                    } }) }) }) })) : null] })] }));
};
exports.ExpectedValueBadge = ExpectedValueBadge;
